// Scanner feedback: synthesized beeps + haptics. We generate tones with the
// Web Audio API instead of shipping .mp3 files — zero bundle weight, no decode
// latency, and it works offline in the PWA.
//
// Browsers only allow an AudioContext to start after a user gesture; the scanner
// is always opened by a button tap, so by the time these fire the context can
// resume cleanly. Everything is wrapped in try/catch so audio is never able to
// break the scan flow on a device that blocks it.

let audioCtx;

const getCtx = () => {
  const Ctor = window.AudioContext || window.webkitAudioContext;
  if (!Ctor) return null;
  if (!audioCtx) audioCtx = new Ctor();
  if (audioCtx.state === "suspended") audioCtx.resume().catch(() => {});
  return audioCtx;
};

// Play a sequence of [frequency, startOffsetSec, durationSec] notes.
const playSequence = (notes, type) => {
  try {
    const ctx = getCtx();
    if (!ctx) return;
    const now = ctx.currentTime;
    notes.forEach(([freq, start, dur]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = type;
      osc.frequency.value = freq;
      // Tiny attack/release envelope so the note doesn't click.
      gain.gain.setValueAtTime(0.0001, now + start);
      gain.gain.exponentialRampToValueAtTime(0.25, now + start + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + start);
      osc.stop(now + start + dur + 0.02);
    });
  } catch {
    /* audio unavailable — ignore, scanning still works */
  }
};

/** Bright rising two-note chime for a confirmed, valid scan. */
export const playSuccess = () =>
  playSequence([[880, 0, 0.09], [1320, 0.09, 0.12]], "sine");

/** Low double buzz for a failed/invalid read. */
export const playError = () =>
  playSequence([[200, 0, 0.16], [160, 0.18, 0.2]], "square");

/** Haptic pulse where supported (mobile). Silently no-ops on desktop/iOS Safari. */
export const vibrate = (pattern) => {
  try {
    navigator.vibrate?.(pattern);
  } catch {
    /* ignore */
  }
};
